<template>
  <section>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
      >
        <el-table-column
          width="20px"
          align="center">
        </el-table-column>
        <el-table-column
          width="150"
          label="Created">
          <template #default="{row}">
            <div
              class="flex-column">
              <span>{{row.created_at}} </span>

            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="Type">
          <template #default="{ row }">
            <div class="text">
              <span>{{ row.type }}</span><br>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Request URL"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span>{{ row.request_url }}</span><br>
          </template>
        </el-table-column>
        <el-table-column
          min-width="180"
          label="Reqeust Params">
          <template #default="{ row }">
            <span  class="text-over-hidden">{{ row.request_params }}</span><br>
          </template>
        </el-table-column>
        <el-table-column
          min-width="180"
          label="Response Result">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="text-over-hidden">{{ row.response_result }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{ row.status }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
        >
          <template #default="{ row }">
            <div class="flex-algin">
              <font-awesome-icon
                class="icon"
                icon="info-circle"
                @click="handleShowDetail(row)"></font-awesome-icon>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <api-detail-dailog
      v-model="showApiDialog"
      :data="apiData"></api-detail-dailog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getApiLogList} from '@/api/order'
import {mapActions, mapState} from 'vuex'
import ApiDetailDailog from './api-detail-dailog'
export default {
  name: 'apiLogList',
  components:{
    ApiDetailDailog
  },

  mixins: [MixinOptions],
  props:{
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData:[],
      showApiDialog:false,
      apiData:{}
    }
  },
  computed:{
    orderId(){
      return this.$route.query.id
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getApiLogList()
      }
    }
  },
  methods: {
    handleShowDetail(data){
      this.apiData = data
      this.showApiDialog = true
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getApiLogList()
    },
    network() {
      return {
        getApiLogList: async () => {
          const { data } = await getApiLogList({
            order_id:this.orderId
          })
          this.tableData = data
          this.pageConfig.total = data.length||0
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table{
  font-size: 12px;
  color: #24292E;
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
    .unname{
      font-style: italic;
      color: #6A737D;
    }
  }
  p:first-child{
    color: #24292E;
    font-size: 14px;
    font-weight: 500;
  }
  .login-text{
    color: #24292E;
    font-family: Inter;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 17px;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text{
    color: #24292E;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
  }
}
.transparent{
  margin-top: 15px;
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    color: #24292E!important;
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      .cell{
        line-height: 23px;
        position: relative;
        height: inherit;
        padding: 0;
        //overflow: hidden;
        //white-space: nowrap;
        //text-overflow: ellipsis;
      }
    }
  }
  th{
    .cell{
      padding: 0;
    }
  }
  .text-over-hidden{
    max-width: 220px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

}
</style>
